module.exports = __webpack_public_path__ + "static/img/KrisnaSatriaGunawan.f8abf53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/KrisnaSatriaGunawan.png
// module id = Ait4
// module chunks = 36